<template>
  <div class="notifications-list">
    <p
      v-if="!hasNotifications"
      class="notifications-list__description"
    >
      {{ $t('HOUSE_BOARD_NO_NOTIFICATIONS') }}
    </p>

    <notification-item
      v-for="item in notifications"
      :key="item.id"
      :isSlideable="isSlideable"
      :notification="item"
    />

  </div>
</template>

<script>
import NotificationItem from '~/components/notification-item'

export default {
  components: {
    NotificationItem
  },

  props: {
    notifications: {
      type: Array,
      default () {
        return []
      }
    },
    isSlideable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasNotifications () {
      return this.notifications.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-list {
  &__description {
    color: $color-gray_5;
  }
}
</style>
